import { useMutation, useQueryClient } from '@tanstack/react-query';
import type { TenantDto, UpdateTenantSettingsInput } from '@cutlyft/zod-schemas';
import { apiClient } from '@/lib/api-client';
import { queryKeys } from '@/lib/query-keys';

interface UpdateTenantApiResponse {
  success: boolean;
  data: TenantDto;
}

/**
 * Mutation hook for updating current tenant settings.
 * Calls PATCH /tenant/me.
 */
export function useUpdateTenant() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (input: UpdateTenantSettingsInput) => {
      const response = await apiClient.patch<UpdateTenantApiResponse>('/tenant/me', input);
      return response.data.data;
    },
    onSuccess: (data) => {
      // Invalidate tenant me queries to refetch fresh settings
      queryClient.setQueryData(queryKeys.tenant.me(), (old: any) => {
        if (!old) return old;
        return {
          ...old,
          tenant: data,
        };
      });
      // Also invalidate general auth/me context queries since tenant metadata might have changed
      queryClient.invalidateQueries({ queryKey: queryKeys.auth.me() });
    },
  });
}
